import { render, staticRenderFns } from "./Interests.vue?vue&type=template&id=2e2d12ee&scoped=true&"
import script from "./Interests.vue?vue&type=script&lang=js&"
export * from "./Interests.vue?vue&type=script&lang=js&"
import style0 from "./Interests.vue?vue&type=style&index=0&id=2e2d12ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2d12ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VContainer,VIcon})
